/**
 * Which taper steps a band actually spans.
 *
 * On a per-mark segment the rate is not the tier's own — it comes from the
 * segment's portfolio-size taper, and one band can straddle two steps of it.
 * Gold at 501–2,000 marks sits across both the ≤1,000 step and the ≤2,500 one,
 * so it has two rates, not one.
 *
 * Returns the steps with their index in the original taper, so an edit can be
 * written back to the right place.
 *
 * @param {Array<{up_to: number|null, rate: number}>} taper
 * @returns {Array<{index: number, up_to: number|null, rate: number}>}
 */
export const stepsForBand = (taper, minMarks, maxMarks) => {
  if (!Array.isArray(taper) || !taper.length) return [];
  const lo = Number(minMarks) || 0;
  const hi = maxMarks == null || maxMarks === "" ? Infinity : Number(maxMarks);
  const out = [];
  let from = 0;
  taper.forEach((step, index) => {
    const upTo = step.up_to == null ? Infinity : Number(step.up_to);
    // The step covers (from, upTo]; keep it when that overlaps the band.
    if (upTo >= lo && from < hi) out.push({ index, up_to: step.up_to, rate: step.rate });
    from = upTo;
  });
  return out;
};

export const ratesForBand = (taper, minMarks, maxMarks) =>
  [...new Set(stepsForBand(taper, minMarks, maxMarks).map((s) => Number(s.rate)))];

export const rateText = (n) =>
  `₹${Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const marksText = (n) =>
  n == null ? "above" : `up to ${Number(n).toLocaleString("en-IN")}`;
